import React from 'react';

import PublicRouter from './routes/PublicRouter';

const App: React.FunctionComponent = () => <PublicRouter />;

export default App;
